export const COOKIE_SELECTED_PRODUCT = 'bonkers-ie-selected-product';
export const COOKIE_LOAN_SEARCH = 'bonkers-ie-loan-search';
export const COOKIE_MORTGAGE_JOURNEY = 'bonkers-ie-mortgage-journey';
